import { Serializable } from '@admin/core/models/serializable';
import { BannerStatusEnum } from './banner-status-enum';
import { BannerTargetEnum } from './banner-target-enum';
import { BannerTypeEnum } from './banner-type-enum';

export class BannerViewModel implements Serializable<BannerViewModel> {
  fromObject(object: any): BannerViewModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    return {
      BannerId: this.bannerId,
      PositionId: this.positionId,
      StatusId: this.statusId,
      TypeId: this.typeId,
      TargetId: this.targetId,
      Name: this.name,
      ImageFileName: this.imageFileName,
      Link: this.link,
      Code: this.code,
      DeactivationDate: this.deactivationDate,
      ClickCount: this.clickCount,
      ViewCount: this.viewCount,
      ClickRate: this.clickRate,
    };
  }

  public bannerId: number;
  public positionId: number;
  public statusId: BannerStatusEnum;
  public typeId: BannerTypeEnum;
  public targetId: BannerTargetEnum;
  public name: string;
  public imageFileName: string;
  public link: string;
  public code: string;
  public deactivationDate: Date;
  public clickCount: number;
  public viewCount: number;
  public clickRate: number;

  constructor() {}
}
